import React, { createContext, useState } from 'react';

import { useSelector } from 'react-redux';
import { IEnrollment, IEnrollmentContextProps } from '../common/types';
import { useEnrollmentFormContext } from './useEnrollmentFormContext';

export const EnrollmentContext = createContext<IEnrollmentContextProps>({
    selectedEnrollment: {} as IEnrollment,
    enrollments: [],
    setEnrollments: () => {},
    disableContinue: false,
    isMrcClicked: false,
    isEdit: false,
    disableMRCEdit: false,
    enableContinueButton: () => {},
    disableContinueButton: () => {},
    enrollmentPremiumFormContext: () => {},
    setIsEdit: () => {},
    viewAddOrChangeTxn: false,
    setViewAddOrChangeTxn: () => {},
});

export const MemberMyEnrollmentProvider = ({ children }) => {
    const [enrollments, setEnrollments] = useState([]);
    const [isEdit, setIsEdit] = useState(false);
    const [disableMRCEdit, setDisableMRCEdit] = useState(false);
    const [disableContinue, setDisableContinue] = useState(false);
    const [isMrcClicked, setisMrcClicked] = useState(false);
    const [viewAddOrChangeTxn, setViewAddOrChangeTxn] = useState(false);
    const { selectedEnrollment } = useSelector((state: { memberEnrollment: any }) => state.memberEnrollment);
    const { ...methods } = useEnrollmentFormContext({ isEdit });

    const enableContinueButton = () => {
        setDisableContinue(true);
        setDisableMRCEdit(true);
    };
    const disableContinueButton = () => {
        setDisableContinue(false);
        setDisableMRCEdit(false);
    };

    const value = {
        selectedEnrollment,
        disableContinue,
        isMrcClicked,
        enrollments,
        isEdit,
        disableMRCEdit,
        viewAddOrChangeTxn,
        setEnrollments,
        setIsEdit,
        setDisableMRCEdit,
        enableContinueButton,
        setisMrcClicked,
        disableContinueButton,
        setViewAddOrChangeTxn,
        enrollmentPremiumFormContext: { ...methods },
    };

    return <EnrollmentContext.Provider value={value}>{children}</EnrollmentContext.Provider>;
};
